import { useMemo } from "react";

import { MediaMetaData } from "../../shared/interfaces/Result";
import { FilterState } from "./MediaFilters";
import { useMediaByDataPointIdAndFilepath } from "../../data/useMediaByDataPointIdAndFilepath";

interface Props {
  mediaMetaData: MediaMetaData[];
  filters: FilterState;
  isPartialResult: boolean | undefined;
}

export interface Media extends MediaMetaData {
  imageIndex?: number;
  display?: boolean;
  isImage?: boolean;
}

export function useMedia(props: Props) {
  const mediaData = useMediaByDataPointIdAndFilepath(props.mediaMetaData);

  const media: Media[] = useMemo(() => {
    return mediaData.map((md) => {
      return {
        ...md.data,
        isImage: md.data?.mimeType?.includes("image"),
        display: shouldMediaItemBeDisplayed(md.data, props.filters, props.isPartialResult),
        loading: md.isLoading,
        error: md.error,
      } as Media;
    });
  }, [mediaData, props.filters, props.isPartialResult]);

  const images = useMemo(() => {
    let imageList: MediaMetaData[] = [];

    media.forEach((m) => {
      if (m.isImage && m.display) {
        const listLength = imageList.push(m);
        m.imageIndex = listLength - 1;
      }
    });

    return imageList;
  }, [media]);

  return { media: media, imageList: images };
}

function shouldMediaItemBeDisplayed(
  mediaItem: MediaMetaData | undefined,
  filters: FilterState,
  isPartialResult: boolean | undefined,
) {
  let shouldDisplay = false;
  if (
    filters.assets?.some(
      (asset) =>
        (isPartialResult && asset.name === mediaItem?.SurveyAssetName) ||
        (!isPartialResult && asset.id === mediaItem?.AssetId),
    ) ||
    filters.assets === undefined
  ) {
    shouldDisplay = true;
  }

  if (!filters.media.photos && mediaItem?.mimeType?.includes("image")) {
    shouldDisplay = false;
  } else if (!filters.media.videos && mediaItem?.mimeType?.includes("video")) {
    shouldDisplay = false;
  }

  return shouldDisplay;
}
